import React, { useEffect, useState } from "react";
import { Select, MenuItem, FormControl, InputLabel, SelectChangeEvent } from "@mui/material";

interface RowsPerPageDropdownProps {
  pageSize: number;
  onPageSizeChange: (newPageSize: number) => void;
}

const RowsPerPageDropdown: React.FC<RowsPerPageDropdownProps> = ({
  pageSize,
  onPageSizeChange,
}) => {
  const [rowsPerPage, setRowsPerPage] = useState<number>(pageSize || 10);

  useEffect(() => {
    // Load saved rows per page value from sessionStorage or default to 10
    const savedRowsPerPage =
      Number(sessionStorage.getItem("rowsPerPage")) || 10;
    setRowsPerPage(savedRowsPerPage);
    onPageSizeChange(savedRowsPerPage);
  }, [onPageSizeChange]);

  const handleChange = (event: SelectChangeEvent<number>) => {
    const newPageSize = Number(event.target.value);
    setRowsPerPage(newPageSize);
    sessionStorage.setItem("rowsPerPage", newPageSize.toString());
    onPageSizeChange(newPageSize);
  };

  return (
    <FormControl
      variant="outlined"
      size="small"
      style={{
        minWidth: "120px", // Ensure enough space for the label and select box
        whiteSpace: "nowrap",
      }}
    >
      <InputLabel>Records per page</InputLabel>
      <Select value={rowsPerPage} onChange={handleChange} label="Records per page">
        <MenuItem value={10}>10 rows</MenuItem>
        <MenuItem value={25}>25 rows</MenuItem>
        <MenuItem value={50}>50 rows</MenuItem>
        <MenuItem value={100}>100 rows</MenuItem>
      </Select>
    </FormControl>
  );
};

export default RowsPerPageDropdown;
